"use client"
import React, { useEffect, useMemo, useRef, useState } from "react";
import { ContextData, storeAssigned, _logoutFunction } from "@/services/Methods/normalMethods";
import { _productPayload, _storeCustomerTypes } from "@/services/Methods/commonPayload";
import localStorageCall from "@/services/Methods/localstorage.hook";
import { _getCountryCodeApi } from "@/services/Redux/Reducer/CustomerSlice";
import { createSelector } from "@reduxjs/toolkit";
import { useDispatch, useSelector } from "react-redux";
import withRouteHOC from "@/HOC/withRouterHOC"
import withMiniCartHOC from "@/HOC/withMinCartHOC";
import _ from "lodash";
import "react-datepicker/dist/react-datepicker.css";
import { getOrders } from "@/services/Redux/Reducer/OrderSlice";
import Header from "@/comman/Header/Header";
import ShoppingCartComponent from "@/comman/ShoppingCartComponent";
import Footer from "@/comman/Footer/Footer";
import useScript from "../../services/Methods/UseScript.hook";
import JoinPopup from "@/comman/JoinPopup";
import * as Sentry from "@sentry/react";
import ButtonComponent from "@/Inputs/ButtonComponent";
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import useIpDetection from "../../../hooks/useIpDetection";
import { useRouter } from "next/navigation";
import Sharethispage from "@/comman/ShareThisPage";
import { calculateDataUserPayload } from "@/services/Methods/checkoutPayloads";
import { CalculateLiteApi } from "@/services/Redux/Reducer/CheckoutSlice";

const STORES = ["ae", "at", "be", "bg", "br", "by", "cl", "co", "cr", "cy", "cz", "de", "dk", "ec", "ee", "es", "fi", "fr", "gr", "hr", "hu", "ie", "il", "it", "jo", "kh", "kz", "la", "lk", "lt", "lu", "lv", "mk", "mt", "mx", "my", "nl", "no", "pa", "pe", "ph", "pl", "ps", "pt", "ro", "ru", "se", "si", "sk", "th", "ua", "us"];

const Template = ({ children, ...props }) => {
    const { pathname, searchParams, params, redirect, isUserLogin, checkoutRef } = props;

    const { calculateLiteData } = useSelector((state) => (state.CheckoutSlice));

    console.log("calculateLiteDatacalculateLiteDatacalculateLiteData",calculateLiteData);

    const [showCountries, setShowCountries] = useState(false);
    const dispatch = useDispatch();
    const menuRef = useRef(null);
    const buttonRef = useRef(null);
    const [orders, setOrders] = useState([])
    const [selectedStore, setSelectedStore] = useState({ defaultCode: 'us', newCode: 'us' });
      const [countriesShow, setCountriesShow] = useState(false);

    const [userIp, setUserIp] = useState()
    const [storeAssign, setStoreAssign] = useState();
    const router = useRouter();
    const CUSTOMER_TYPE = localStorageCall().getItem('customerTypeDescr');

    const PRODUCT_DATA = props?.addToCartProducts?.normalProducts;

    const handleOutsideClick = (event) => {
        if (
            menuRef.current &&
            !menuRef.current.contains(event.target) &&
            event.target !== buttonRef.current
        ) {
            setShowCountries(false);
        }
    };
    useEffect(() => {
        localStorageCall().removeItem('activeStep');
        document.addEventListener('mousedown', handleOutsideClick);
        return () => {
            document.removeEventListener('mousedown', handleOutsideClick);
        };
    }, []);

    const MEMBERSHIP_AVAILABLE = _.find(localStorageCall().getItem('normalProducts'), { frequency: "member" }) || null;

    if (!_.includes(pathname, 'main-enrollment') && MEMBERSHIP_AVAILABLE) {
        localStorageCall().removeItem('normalProducts');
    }

    const [isScrolled, setIsScrolled] = useState(false);


    function _onCalculateLiteApiCall(ADD_PRODUCTS, sec) {
        console.log("calculateLiteData?.data?.crmOrder?.priceTypecalculateLiteData?.data?.crmOrder?.priceType",calculateLiteData?.data?.crmOrder?.priceType)
        const selectedShippingOption = {
            section: 'normal',
            autoshipSelectedShipping: { shipCarrierId: null, shipMethodType: null },
            oneTimeSelectedShipping: { shipCarrierId: null, shipMethodType: null }
        };
        const useDefaultAddressOrNot = { bypassOrNot: true, addessData: null };

        let calculteDataUser = calculateDataUserPayload(null, selectedShippingOption, useDefaultAddressOrNot?.bypassOrNot);
        const detailsArray = _productPayload(ADD_PRODUCTS);
        calculteDataUser["details"] = detailsArray;
        calculteDataUser['country'] = _.upperCase(storeAssigned());
        calculteDataUser["lastName"] = 'Bhip';
        const CUSTOMER_TYPE = localStorageCall().getItem('customerTypeDescr');
        calculteDataUser["priceType"] = calculateLiteData?.data?.crmOrder?.priceType  ? calculateLiteData?.data?.crmOrder?.priceType : _.includes(['prospect'], CUSTOMER_TYPE?.role) ? 4 : _.includes(['company'], CUSTOMER_TYPE?.role) ? 3 : _.includes(['Professional'], CUSTOMER_TYPE?.customerSubTypeDescr) ? 5 : _.includes(['Executive'], CUSTOMER_TYPE?.customerSubTypeDescr) ? 4 : _.includes(['Partner'], CUSTOMER_TYPE?.customerSubTypeDescr) ? 3 : (_.includes(['Associate'], CUSTOMER_TYPE?.customerSubTypeDescr) || sec === 'distributor') ? 2 : 1
        dispatch(CalculateLiteApi(calculteDataUser, (data) => console.log("ErrorData", data)));
    }

    useEffect(() => {

        const cartProducts = localStorageCall().getItem('normalProducts') || [];
        if (cartProducts?.length > 0) {
            if(_.includes(pathname, 'distributor')){
                _onCalculateLiteApiCall(cartProducts, 'distributor')


            }else{
                _onCalculateLiteApiCall(cartProducts, 'normal')

            }
        }
        const handleScroll = () => {
            if (window.scrollY > 50) {
                setIsScrolled(true);
            } else {
                setIsScrolled(false);
            }
        };

        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);



    const getData = createSelector(
        state => state.CustomerSlice,
        state => state?.LoginSlice?.alluserData,
        state => state?.PaymentSlice?.paymentScript,
        state => state?.LoginSlice?.volumeData,
        ({ countryData, isLoading }, userData, paymentScript, volumeData) => ({
            isLoading,
            countryCodes: _.map(countryData, 'countryCode')?.length > 0 ? _.map(countryData, 'countryCode') : [],
            countyObjects: _.map(countryData, (row) => ({ code: row?.countryCode, name: row?.countryName, currency: row?.currency })),
            userData: userData, paymentScript, volumeData,
        })
    );

    const { isLoading, countryCodes, countyObjects, paymentScript, userData, volumeData } = useSelector((state) => getData(state));

    useIpDetection(STORES, params?.store, router, pathname, isUserLogin, setUserIp);

    const LifetimeBV = volumeData && volumeData?.find(
        (item) => item.volumeGroupType === 1 && item.volumeType === 25
    );

    const totalCvAutoship = useMemo(() => {
        return (LifetimeBV?.value || 0) + PRODUCT_DATA?.reduce((total, product) => total + ((product.cv_autoship || 0) * (product.quantity || 1)), 0);
    }, [PRODUCT_DATA]);

    useScript(paymentScript);

    useEffect(() => { dispatch(_getCountryCodeApi()); }, []);

    useEffect(() => {

        const DEFAULT_STORE = localStorageCall()?.getSingleItem('store');

        if (!DEFAULT_STORE) {
            if (STORES?.includes(params?.store)) {
                localStorageCall().setItem('store', params?.store)
            }
        } else {
            if (DEFAULT_STORE !== params?.store) {
                if (STORES?.includes(params?.store)) {
                    localStorageCall().setItem('store', params?.store);
                    setSelectedStore({ defaultCode: params?.store, newCode: params?.store });
                } else {
                    setSelectedStore({ defaultCode: DEFAULT_STORE, newCode: DEFAULT_STORE });
                }
            } else {
                setSelectedStore({ defaultCode: DEFAULT_STORE, newCode: DEFAULT_STORE });
            }
        }

        const weglotScript = document.createElement('script');
        weglotScript.src = "https://cdn.weglot.com/weglot.min.js";
        weglotScript.async = true;
        weglotScript.onload = () => {
            if (window.Weglot) {
                Weglot.initialize({
                    api_key: 'wg_dcb2ef458c9a4e857e5eefd844a45f9d0',
                });
            }
        };

        document.head.appendChild(weglotScript);

        // const zendeskScript = document.createElement('script');
        // zendeskScript.id = "ze-snippet";
        // zendeskScript.src = "https://static.zdassets.com/ekr/snippet.js?key=c1c6e6aa-6c00-48c7-8f9a-1936ac92a03d";
        // zendeskScript.async = true;

        // document.head.appendChild(zendeskScript);

        // Cleanup function to remove scripts on unmount
        return () => {
            document.head.removeChild(weglotScript);
            // document.head.removeChild(zendeskScript);
        };

    }, [pathname]);


    useEffect(() => {
        if (STORES?.includes(params?.store)) {
            localStorageCall().setItem('store', params?.store)
        }

    }, [pathname]);

    useEffect(() => {
        if (isUserLogin && userData === null) {
            _storeCustomerTypes(dispatch, isUserLogin, searchParams);
        }

        // dispatch(getOrders(null, isUserLogin, (res) => {
        //     setOrders(res?.data)
        // }))
    }, [isUserLogin]);


    const [joinPopup, setJoinPopup] = useState(false);

    // if (userData?.emailAddress) {
    //     Sentry.setUser({ id: userData?.customerId, email: userData?.emailAddress });
    //     Sentry.setTag("userID", userData?.customerId);
    // }

    const [showPopup, setShowPopup] = useState(false);

    const UserCountry = userData?.countryCode;
    const StoreASSigned = storeAssigned();

    const LOCAL_STORAGE_KEY = 'showPopupDismissed';
    useEffect(() => {
        if (localStorageCall().getItem(LOCAL_STORAGE_KEY)) {
            setShowPopup(false);
        }
    }, [setShowPopup]);

    // const handleClose = () => {
    //     localStorageCall().setItem(LOCAL_STORAGE_KEY, 'true');
    //     setShowPopup(false);
    // };
    const Localkey = localStorageCall()?.getItem(LOCAL_STORAGE_KEY);

    const userIpCountry = localStorageCall().getSingleItem('IpCountry');

    const storeAssignUppercase = StoreASSigned ? StoreASSigned.toUpperCase() : null;
    // console.log("storeAssignUppercase !== userIpCountry", storeAssignUppercase !== userIpCountry, "keyvalue", !Localkey);

    // useEffect(() => {
    //     if (!Localkey) {
    //         console.log("inside my useEffect 1");
    //         setShowPopup(true);
    //     }
    // }, [userData, userIpCountry]);

    useEffect(() => {
        const storeAssignUppercase = StoreASSigned ? StoreASSigned.toUpperCase() : null;
        setStoreAssign(storeAssignUppercase);

        // if (!searchParams.get('ssokey') && UserCountry && storeAssignUppercase && (storeAssignUppercase !== userIpCountry) && (UserCountry !== storeAssignUppercase) && !Localkey) {
        //     setShowPopup(true);
        // }


    }, [userData, pathname]);

    return (
        <>
            {(isUserLogin && CUSTOMER_TYPE?.type === 2) && <div className="sharepage">
                <Sharethispage pathname={pathname} userData={userData} />
            </div>}

            <ContextData.Provider value={{
                showCountries, userData, volumeData, countryCodes, setShowCountries, countyObjects, dispatch, STORES, handleOutsideClick,
                buttonRef, menuRef, orders, selectedStore, setSelectedStore, countriesShow, setCountriesShow,
 checkoutRef, UserCountry, storeAssignUppercase, userIpCountry, Localkey, setShowPopup, showPopup, storeAssign, setStoreAssign, LOCAL_STORAGE_KEY, pathname, totalCvAutoship, isScrolled, setIsScrolled, ...props
            }
            }>

                <Header  {...{
                    showCountries, userData, countryCodes, setShowCountries, countyObjects, dispatch, STORES, handleOutsideClick, buttonRef,
                    menuRef, joinPopup, setJoinPopup, selectedStore, setSelectedStore,countriesShow, setCountriesShow,
                    ...props
                }} />

                <div>{children}</div>
                <Footer {...{ joinPopup, setJoinPopup, userData }} />
                {/* {!_.includes(pathname, 'distributor') && (
                    <> */}
                <ShoppingCartComponent
                    section={_.includes(pathname, 'distributor') ? 'distributor' : 'normal'}
                    pathname={pathname}
                    _changeFrequencyOfProducts={props?._changeFrequencyOfProducts}
                    _minCartQuantityIncDec={props?._minCartAndViewCartQuantityIncDec}
                    openMiniCart={props?.openMiniCart}
                    setOpenMiniCart={props?.setOpenMiniCart}
                    _deleteProductFromCart={props?._deleteProductFromCart}
                    productData={props?.addToCartProducts?.normalProducts}
                    totalCvAutoship={totalCvAutoship}
                    _autoShipCheck={props?._autoShipCheck}
                    userData={userData}
                    volumeData={volumeData} />
                {/* </>
                )
                } */}

            </ContextData.Provider>
            <JoinPopup {...{ joinPopup, setJoinPopup }} />

        </ >
    );
}

export default withRouteHOC(withMiniCartHOC(Template, 'normal'));